export enum AlertButton {
  OK = 1,
  YES,
  NO,
  CANCEL,
  NEXT
}
